import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import { isEmpty } from 'lodash-es';
import MenuItem from './MenuItem.vue';
import AccordionItem from '~/components/Layout/Accordion/AccordionItem.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import ItemMarketingBanner from '~/components/cms/custom/ItemMarketing/ItemMarketingBanner.vue';
export default defineComponent({
  name: 'MenuSubcategoryList',
  components: {
    MenuItem: MenuItem,
    AccordionItem: AccordionItem,
    ItemMarketingBanner: ItemMarketingBanner
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    topLevelCategory: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showTopLevelCategory: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    marketingBanners: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    numberOfItemsStart: Number,
    numberOfItemsEnd: Number,
    hideLinks: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var content = inject('content');
    var menuItemMarketingBanners = computed(function () {
      var _props$topLevelCatego, _props$topLevelCatego2, _props$topLevelCatego3, _props$topLevelCatego4, _props$marketingBanne, _props$topLevelCatego5, _content$marketingBan;
      return (
        // if component in draft we still receive marketingBanners, but with an empty 'fields'
        (_props$topLevelCatego = props.topLevelCategory) !== null && _props$topLevelCatego !== void 0 && (_props$topLevelCatego2 = _props$topLevelCatego.marketingBanners) !== null && _props$topLevelCatego2 !== void 0 && _props$topLevelCatego2.length && Object.keys((_props$topLevelCatego3 = props.topLevelCategory) === null || _props$topLevelCatego3 === void 0 ? void 0 : (_props$topLevelCatego4 = _props$topLevelCatego3.marketingBanners[0]) === null || _props$topLevelCatego4 === void 0 ? void 0 : _props$topLevelCatego4.fields).length || (_props$marketingBanne = props.marketingBanners) !== null && _props$marketingBanne !== void 0 && _props$marketingBanne.length ? ((_props$topLevelCatego5 = props.topLevelCategory) === null || _props$topLevelCatego5 === void 0 ? void 0 : _props$topLevelCatego5.marketingBanners) || props.marketingBanners : content === null || content === void 0 ? void 0 : (_content$marketingBan = content.marketingBanners) === null || _content$marketingBan === void 0 ? void 0 : _content$marketingBan.value
      );
    });
    var hasMarketingBanners = computed(function () {
      var _menuItemMarketingBan, _menuItemMarketingBan2;
      return ((_menuItemMarketingBan = menuItemMarketingBanners.value) === null || _menuItemMarketingBan === void 0 ? void 0 : _menuItemMarketingBan.length) && Object.keys(menuItemMarketingBanners === null || menuItemMarketingBanners === void 0 ? void 0 : (_menuItemMarketingBan2 = menuItemMarketingBanners.value[0]) === null || _menuItemMarketingBan2 === void 0 ? void 0 : _menuItemMarketingBan2.fields).length;
    });
    return {
      translate: translate,
      isEmpty: isEmpty,
      menuItemMarketingBanners: menuItemMarketingBanners,
      hasMarketingBanners: hasMarketingBanners
    };
  }
});